export default "__VITE_ASSET__75u_U6Iu__"